/* ============================================================================
 * Movatic WMS — Frontend | CesarFilho 932048016
 * Arquivo: src/pages/marketing/CampaignsPage.tsx
 * ----------------------------------------------------------------------------
 * Lista de campanhas de marketing.
 *
 * Objetivo:
 * - Dar visibilidade à equipa de marketing e logística sobre campanhas
 *   planeadas / ativas, com datas, canal e estado.
 * - Endpoint: /api/marketing/campaigns/
 *
 * Notas:
 * - Os campos assumidos no payload da API são:
 *     id
 *     company_code        → código da empresa
 *     code                → código curto da campanha
 *     name                → nome descritivo
 *     status              → código do estado (DRAFT, PLANNED, ACTIVE, ...)
 *     sales_channel       → código do canal (ALL, ECOM, ...)
 *     start_date          → AAAA-MM-DD
 *     end_date            → AAAA-MM-DD
 *   Se o serializer ainda não estiver assim, depois ajustamos para bater
 *   com estes nomes.
 * ========================================================================== */

import CrudList from "@/components/CrudList";

export default function CampaignsPage() {
    return (
        <div className="p-4 md:p-6 space-y-4">
            <div className="max-w-3xl text-sm opacity-70">
                Planeamento de campanhas promocionais com impacto logístico:
                volumes previstos, datas, canal e prioridade. Estas informações
                ajudam a logística a antecipar stock, slotting e capacidade de
                receção/picking.
            </div>

            <CrudList
                title="Campanhas de marketing"
                endpoint="/api/marketing/campaigns/"
                columns={[
                    {
                        key: "company_code",
                        header: "Empresa",
                        className: "whitespace-nowrap",
                    },
                    {
                        key: "code",
                        header: "Código",
                        className: "whitespace-nowrap",
                    },
                    {
                        key: "name",
                        header: "Nome",
                        className: "min-w-[260px]",
                    },
                    {
                        key: "status",
                        header: "Estado",
                        className: "whitespace-nowrap",
                    },
                    {
                        key: "sales_channel",
                        header: "Canal",
                        className: "whitespace-nowrap",
                    },
                    {
                        key: "start_date",
                        header: "Início",
                        className: "whitespace-nowrap",
                    },
                    {
                        key: "end_date",
                        header: "Fim",
                        className: "whitespace-nowrap",
                    },
                ]}
            />
        </div>
    );
}
